import type { ComponentProps, ComponentType } from 'react'

import { Box, BoxProps, Grid } from '@mui/material'
import styled from 'styled-components'

import { backgroundColor } from '../Colors'
import { CustomBoxProps } from '../Line/LineStyleComponent'

export const View: ComponentType<BoxProps> = styled(Box)`
  background-color: ${backgroundColor};
` as ComponentType<BoxProps>
//@ts-ignore
export const ViewForShot = styled(Grid).attrs((props: BoxProps & CustomBoxProps) => ({
  container: true,
  sx: {
    borderTopLeftRadius: props.first ? '8px' : '0px',
    borderBottomLeftRadius: props.last ? '8px' : '0px',
    borderTopRightRadius: props.first ? '8px' : '0px',
    borderBottomRightRadius: props.last ? '8px' : '0px',
    boxShadow: props.first
      ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
      : props.last
        ? 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px'
        : 'rgb(0 0 0 / 20%) 0px 3px 1px -2px, rgb(0 0 0 / 14%) 0px 2px 2px 0px, rgb(0 0 0 / 12%) 0px 1px 5px 0px',
    borderBottomStyle: 'solid',
    borderBottomWidth: '0px',
    borderBottomColor: 'rgb(218, 218, 218)',
    marginBottom: props.last ? '8px' : '0px',
    flex: 1,
    ...props.sx
  },
  ...props
}))`
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  align-content: stretch;
  padding-right: 6px;
  padding-left: 6px;
` as React.ComponentType<BoxProps & CustomBoxProps>

export const ViewFlex: ComponentType<ComponentProps<typeof View>> = styled(View)`
  display: flex;
  flex-direction: column;
  min-width: 400px;
  max-width: 550px;
` as ComponentType<ComponentProps<typeof View>>

export const ContainerCalculPage: ComponentType<ComponentProps<typeof View>> = styled(View)`
  display: flex;
  flex-direction: column;
` as ComponentType<ComponentProps<typeof View>>
/**
 * View Row is a View Flex : 1 with flexDirectino row
 */
export const ViewRow: ComponentType<ComponentProps<typeof ViewFlex>> = styled(ViewFlex)`
  flex: 1;
  flex-direction: row;
` as ComponentType<ComponentProps<typeof ViewFlex>>

export const ViewColumn: ComponentType<ComponentProps<typeof ViewFlex>> = styled(ViewFlex)`
  flex: 1;
  flex-direction: column;
  background-color: transparent;
` as ComponentType<ComponentProps<typeof ViewFlex>>

export const TransparentView: ComponentType<BoxProps> = styled(Box)`
  background-color: transparent;
` as ComponentType<BoxProps>

export const ViewRowCenter: ComponentType<ComponentProps<typeof ViewRow>> = styled(ViewRow)`
  align-items: center;
` as ComponentType<ComponentProps<typeof ViewRow>>
